import React from "react";

/**
 * The rail down the left of Product Settings — the master half of the
 * master–detail redesign (v3).
 *
 * Every reference list is named here with its count, and exactly one is open at
 * a time. The counts are the reason the rail earns its width: they stay put
 * while a pane loads, so switching lists never leaves the page looking empty.
 *
 * The marker beside each name is a shape, not an icon font: a square for the
 * plain name-lists, a hatched square for patterns (they carry a picture) and a
 * circle for colours (they are a value, not a category). Two lists sit below a
 * divider because they are the two that do not behave like the rest — patterns
 * are scoped to a fabric, colours are searched on the server.
 *
 * Under 900px the rail stops being a column and becomes a horizontal scroller
 * of chips above the pane; the same counts ride along. That is a CSS change
 * only — see `.ps-rail` in ProductSettings.css — so this component renders one
 * markup shape for both.
 */
export default function ReferenceListRail({ lists, selected, onSelect }) {
  return (
    <nav className="ps-rail" aria-label="Reference lists">
      <div className="ps-rail-label">Reference lists</div>

      {lists.map((list) => (
        <React.Fragment key={list.key}>
          {list.dividerBefore && <div className="ps-rail-divider" />}

          <button
            type="button"
            className={`ps-rail-item ${
              selected === list.key ? "ps-rail-item-active" : ""
            }`}
            aria-current={selected === list.key ? "true" : undefined}
            onClick={() => onSelect(list.key)}
          >
            <span className={`ps-rail-marker ps-rail-marker-${list.marker}`} />
            <span className="ps-rail-name">{list.title}</span>
            <span className="ps-rail-count">
              {list.count === null ? "—" : list.count.toLocaleString()}
            </span>
          </button>
        </React.Fragment>
      ))}
    </nav>
  );
}
